<template>
  <div class="mul-schemes-split">
    <!-- 左侧面板：流量过程线 + 方案对比表 -->
    <div class="pt-panel mul-schemes-left">
      <div class="pt-header">
        <div class="pt-header-text">
          <div class="pt-kicker">工程信息</div>
          <h2 class="pt-title">{{ oneTitle }}</h2>
          <p class="pt-subtitle">流量过程线 · 实测 vs 预测</p>
        </div>
        <button class="pt-close" @click="closeClick">&times;</button>
      </div>

      <div class="pt-section">
        <div class="pt-section-title">
          <strong>流量过程线</strong>
          <span>实测 vs 预测</span>
        </div>
        <flowCurrent ref="flowCurrent" height="220px" width="100%" :chartData="chartData1" />
      </div>

      <div class="pt-section">
        <div class="pt-section-title">
          <strong>方案对比</strong>
        </div>
        <div class="pt-flex-table">
          <div class="pt-flex-table-header">
            <div class="pt-flex-table-cell">方案名称</div>
            <div class="pt-flex-table-cell">峰现时间</div>
            <div class="pt-flex-table-cell">洪峰流量(m³/s)</div>
            <div class="pt-flex-table-cell">重现期</div>
          </div>
          <div class="pt-flex-table-row" v-for="(line, i) in recycleRecordsT" :key="i">
            <div class="pt-flex-table-cell">{{ line.name }}</div>
            <div class="pt-flex-table-cell">{{ line.time }}</div>
            <div class="pt-flex-table-cell">{{ line.flow }}</div>
            <div class="pt-flex-table-cell">{{ line.period }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧面板：精度评定 -->
    <div class="pt-panel mul-schemes-right">
      <div class="pt-header">
        <div class="pt-header-text">
          <div class="pt-kicker">精度评定</div>
          <h2 class="pt-title">精度评定</h2>
          <p class="pt-subtitle">多方案预测 · 甲级</p>
        </div>
      </div>

      <div class="pt-section">
        <div class="pt-section-title">
          <strong>精度评定</strong>
          <span class="pt-badge pt-badge-strong">甲级</span>
        </div>
        <mulSchemeForecast ref="mulSchemeForecast" height="220px" width="100%" :chartData="chartData" />
      </div>

      <div class="pt-section">
        <div class="pt-section-title">
          <strong>评价指标</strong>
        </div>
        <div class="pt-flex-table">
          <div class="pt-flex-table-header">
            <div class="pt-flex-table-cell">指标名称</div>
            <div class="pt-flex-table-cell">评价指标</div>
            <div class="pt-flex-table-cell">率定期</div>
            <div class="pt-flex-table-cell">验证期</div>
          </div>
          <div class="pt-flex-table-row" v-for="(line, i) in evaluate" :key="i">
            <div class="pt-flex-table-cell">{{ line.name }}</div>
            <div class="pt-flex-table-cell">{{ line.indicator }}</div>
            <div class="pt-flex-table-cell">{{ line.ir }}</div>
            <div class="pt-flex-table-cell">{{ line.pr }}</div>
          </div>
        </div>
      </div>

      <div style="text-align: right; margin-top: 12px;">
        <button class="pt-btn pt-btn-success" @click="submit">成果发布</button>
      </div>
    </div>
  </div>
</template>

<script>
import mulSchemeForecast from "@/components/mulSchemeForecast";
import flowCurrent from "@/components/flowCurrent";
import { generateForecast } from '@/services/hydroService.js'
let timer = null;
export default {
  name: "mulSchemes",
  components: { mulSchemeForecast, flowCurrent },
  data() {
    return {
      oneTitle: "预测方案",
      chartData: '',
      chartData1: null,
      recycleRecordsT: [
        { name: '实测', time: '未知', flow: '未知', period: '未知' }
      ],
      evaluate: [
        { name: "合格率", indicator: "QR", ir: "0.31", pr: "0.33" },
        { name: "确定性系数", indicator: "DC", ir: "0.00", pr: "0.14" },
        { name: "标准化均方根误差", indicator: "NRMSE", ir: "0.00", pr: "0.14" },
        { name: "纳什效率系数", indicator: "NSE", ir: "0.00", pr: "0.14" },
        { name: "平均绝对误差", indicator: "MAE", ir: "0.00", pr: "0.14" },
        { name: "峰值预测性能指标", indicator: "PPTS", ir: "0.00", pr: "0.14" }
      ],
      scrollTop: 0,
      speed: 15,
      copyHtml: '',
      data: [null, null, null, null, null, null, 598, 820, 900, 640, 510, 370, 200]
    }
  },
  mounted() {
    // 自动初始化默认数据（汛期洪水来水方案）
    this.$nextTick(() => {
      this.init(2).catch(() => {})
    })
  },
  destroyed() {
    clearInterval(timer)
  },
  methods: {
    async init(num, reservoirName) {
      this.recycleRecordsT = []
      // 如果传入水库名，使用该水库作为站点；否则按原逻辑选择
      const station = reservoirName || (num === 2 ? '龙门水文站' : '张家卯监测点')
      const forecast = await generateForecast({
        horizon_hours: 24,
        station: station,
        scenario: num === 2 ? '汛期洪水来水' : '枯季径流来水',
        peak_flow: num === 2 ? 2380 : 1680,
        base_flow: num === 2 ? 760 : 520,
      })
      // 更新面板标题，显示当前水库
      if (reservoirName) {
        this.oneTitle = reservoirName + ' · 预测方案'
      }
      this.recycleRecordsT.push(
        { name: '实测', time: forecast.times[forecast.observed.length - 1] || '当前', flow: forecast.observed[forecast.observed.length - 1] || '未知', period: '实时监测' },
        { name: 'P50 预测方案', time: forecast.metrics.peak_time, flow: forecast.metrics.peak_flow, period: num === 2 ? '百年一遇' : '平水年' },
        { name: 'P90 偏丰方案', time: forecast.metrics.peak_time, flow: Math.round(forecast.metrics.peak_flow * 1.18), period: num === 2 ? '超警戒' : '偏丰' },
        { name: 'P10 偏枯方案', time: forecast.metrics.peak_time, flow: Math.round(forecast.metrics.peak_flow * 0.84), period: num === 2 ? '可控洪水' : '偏枯' }
      )
      this.evaluate = [
        { name: "合格率", indicator: "QR", ir: forecast.metrics.qr.toFixed(2), pr: (forecast.metrics.qr - 0.03).toFixed(2) },
        { name: "确定性系数", indicator: "DC", ir: forecast.metrics.dc.toFixed(2), pr: (forecast.metrics.dc - 0.04).toFixed(2) },
        { name: "纳什效率系数", indicator: "NSE", ir: forecast.metrics.nse.toFixed(2), pr: (forecast.metrics.nse - 0.05).toFixed(2) },
        { name: "平均绝对误差", indicator: "MAE", ir: forecast.metrics.mae.toFixed(1), pr: (forecast.metrics.mae * 1.12).toFixed(1) },
        { name: "均方根误差", indicator: "RMSE", ir: forecast.metrics.rmse.toFixed(1), pr: (forecast.metrics.rmse * 1.1).toFixed(1) },
        { name: "峰值预测性能", indicator: "PPTS", ir: "0.89", pr: "0.86" },
      ]
      this.chartData = num === 2 ? '1' : '2'
      this.$nextTick(() => this.initScroll())
    },
    cancelBack() { this.$emit("changeScheme") },
    closeClick() { this.$emit('nextChange') },
    initScroll() {
      this.copyHtml = this.$refs.content ? this.$refs.content.innerHTML : ''
      this.startScroll()
    },
    mEnter() { clearInterval(timer); },
    mLeave() { this.startScroll() },
    startScroll() { timer = setInterval(this.scroll, this.speed); },
    scroll() {
      this.scrollTop++
      let scrollItemBox = this.$refs.content ? this.$refs.content.offsetHeight : 0
      if (this.scrollTop >= scrollItemBox) { this.scrollTop = 0 }
    },
    submit() {
      this.$confirm('确定发布此预报结果？', '成果发布', {
        distinguishCancelAndClose: true,
        confirmButtonText: '保存',
        cancelButtonText: '放弃修改'
      }).then(() => {
        this.$emit('changeScheme')
        this.$notify({ type: 'success', message: '已发布' });
      }).catch(action => {
        this.$notify({ type: 'info', message: '已取消' })
      });
    }
  }
}
</script>

<style scoped>
/* 拆分为左右两个面板，中间留空显示水库 */
.mul-schemes-split {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.mul-schemes-left {
  width: 28%;
  height: 78%;
  position: absolute;
  left: 16px;
  top: 120px;
  pointer-events: auto;
}

.mul-schemes-right {
  width: 28%;
  height: 78%;
  position: absolute;
  right: 16px;
  top: 120px;
  pointer-events: auto;
}
</style>
